import { Observable } from 'rxjs';
import { ModalService } from 'ui-components/services/modal-service';
import { BulkErrorsAndWarningsModal } from '../../components/modals/bulk-errors-and-warnings-modal';
import * as InventoryActions from '../../store/inventory/inventory.actions';
import * as Actions from './bulk-errors-and-warnings.actions';

export const bulkErrorsAndWarningsModalObservable = ({
  continueCanBeDisabled,
  dataType,
  errorsAndWarnings,
  fulfillmentPlanSetId,
  hasAdditionalAction,
  hasSelectedItems,
  isBatchPrinting,
  onContinueAction,
  selectedItems,
  title,
  skipInventoryActions,
}) => {
  return new Observable((observer) => {
    // dispatched for analytics only
    observer.next(
      Actions.openBulkErrorsAndWarningsModal(
        dataType,
        errorsAndWarnings,
        title,
        selectedItems,
        onContinueAction,
        continueCanBeDisabled,
        fulfillmentPlanSetId,
        isBatchPrinting,
      ),
    );

    const onContinue = (errsAndWarns) => {
      observer.next(onContinueAction(errsAndWarns));
      observer.complete();
    };

    ModalService.launchModal({
      component: BulkErrorsAndWarningsModal,
      props: {
        dataType,
        errorsAndWarnings,
        fulfillmentPlanSetId,
        onContinue,
        continueCanBeDisabled,
        isBatchPrinting,
        title,
        selectedItems, // BTC - everything in BEWM uses fulfillmentPlan data at this time
        hasSelectedItems, // initial value only
        hasAdditionalAction,
      },
      onClose: () => {
        observer.next(Actions.cancelBulkErrorsAndWarnings());
        observer.complete();
      },
    });

    if (!skipInventoryActions && selectedItems && selectedItems.length > 0) {
      return observer.next(InventoryActions.deallocateFulfillmentPlansSilently(selectedItems.map((item) => item.fulfillmentPlanId)));
    }
  });
};
